var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('gl-breadcrumb',{attrs:{"items":_vm.breadcrumbs}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }